module.exports = __webpack_public_path__ + "img/TikToklogo.8798ec77.png";